/* Kallistia Shared Drawers — Track Order + Subscription
   Load this on any page that renders kl-track-drawer or kl-sub-drawer snippets.
   Must load BEFORE any script that calls window.klDrawers (e.g. kl-help-center.js). */

(function() {
  'use strict';

  // ============ UTILITIES ============
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatDate(str) {
    if (!str) return '';
    try {
      var d = new Date(str);
      if (isNaN(d.getTime())) return str;
      return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch(e) { return str; }
  }

  function setLoading(btn, loading) {
    btn.disabled = loading;
    btn.querySelector('.kl-hc-track-submit-label').style.display = loading ? 'none' : '';
    btn.querySelector('.kl-hc-track-submit-loading').style.display = loading ? '' : 'none';
  }

  // ============ ORDER TRACKING DRAWER ============
  var trackDrawer = document.getElementById('klHcTrackDrawer');
  var trackOverlay = document.getElementById('klHcTrackOverlay');
  var trackClose = document.getElementById('klHcTrackClose');
  var trackError = document.getElementById('klHcTrackError');
  var trackResult = document.getElementById('klHcTrackResult');
  var emailForm = document.getElementById('klHcTrackEmailForm');
  var trackNumForm = document.getElementById('klHcTrackNumForm');
  var TRACK_API = 'https://app.kallistia.com/api/track-order';

  // iOS scroll lock — position:fixed trick
  var drawerScrollY = 0;

  // Current email for "back" navigation
  var currentLookupEmail = '';
  // Cache last order list response so back button doesn't re-fetch
  var cachedOrderList = null;
  // Cache order detail responses so re-visiting an order is instant
  var cachedOrderDetails = {};

  // -- Drawer open/close --
  function openTrackDrawer() {
    if (!trackDrawer) return;
    trackDrawer.classList.add('open');
    trackOverlay.classList.add('open');
    /* iOS/Instagram scroll lock — position:fixed trick */
    drawerScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + drawerScrollY + 'px';
    document.body.style.width = '100%';
    // Restore form state from sessionStorage on fresh page load
    var emailInput = document.getElementById('klHcEmail');
    if (emailInput && !emailInput.value) {
      try {
        var saved = JSON.parse(sessionStorage.getItem('kl_track'));
        if (saved) {
          if (saved.email) emailInput.value = saved.email;
          var orderNumInput = document.getElementById('klHcOrderNum');
          if (orderNumInput && saved.orderNum) orderNumInput.value = saved.orderNum;
          var trackNumInput = document.getElementById('klHcTrackNum');
          if (trackNumInput && saved.trackNum) trackNumInput.value = saved.trackNum;
          if (saved.tab && saved.tab !== 'email') setTrackTab(saved.tab);
        }
      } catch(e) {}
    }
    // Focus first input
    setTimeout(function() {
      var inp = trackDrawer.querySelector('form:not([style*="display:none"]) input');
      if (inp) inp.focus();
    }, 100);
  }

  function closeTrackDrawer() {
    if (!trackDrawer) return;
    /* kl-closing carries the close-direction transition. Default state has
       transition: none so the drawer can never animate on page load. */
    trackDrawer.classList.add('kl-closing');
    trackDrawer.classList.remove('open');
    trackOverlay.classList.remove('open');
    trackDrawer.addEventListener('transitionend', function onEnd(e) {
      if (e.target !== trackDrawer || e.propertyName !== 'transform') return;
      trackDrawer.classList.remove('kl-closing');
      trackDrawer.removeEventListener('transitionend', onEnd);
    });
    /* Restore scroll — undo iOS position:fixed trick */
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, drawerScrollY);
    // Save form state to sessionStorage
    try {
      var emailInput = document.getElementById('klHcEmail');
      var orderNumInput = document.getElementById('klHcOrderNum');
      var trackNumInput = document.getElementById('klHcTrackNum');
      var activeTab = document.querySelector('.kl-hc-track-tab.active');
      sessionStorage.setItem('kl_track', JSON.stringify({
        email: emailInput ? emailInput.value : '',
        orderNum: orderNumInput ? orderNumInput.value : '',
        trackNum: trackNumInput ? trackNumInput.value : '',
        tab: activeTab ? activeTab.getAttribute('data-track-tab') : 'email'
      }));
    } catch(e) {}
  }

  if (trackDrawer) {
    if (trackClose) trackClose.addEventListener('click', closeTrackDrawer);
    if (trackOverlay) trackOverlay.addEventListener('click', closeTrackDrawer);

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && trackDrawer.classList.contains('open')) {
        closeTrackDrawer();
      }
    });
  }

  // -- Tab switching (preserves results per tab) --
  var tabResultCache = { email: '', tracking: '' };
  var tabResultVisible = { email: false, tracking: false };
  var activeTrackTab = 'email';

  function setTrackTab(tabName) {
    if (!trackResult || !emailForm || !trackNumForm) return;
    // Save current tab's result before switching
    if (activeTrackTab) {
      tabResultCache[activeTrackTab] = trackResult.innerHTML;
      tabResultVisible[activeTrackTab] = trackResult.classList.contains('visible');
    }
    activeTrackTab = tabName;
    document.querySelectorAll('.kl-hc-track-tab').forEach(function(t) {
      t.classList.toggle('active', t.getAttribute('data-track-tab') === tabName);
    });
    emailForm.style.display = tabName === 'email' ? '' : 'none';
    trackNumForm.style.display = tabName === 'tracking' ? '' : 'none';
    if (trackError) trackError.classList.remove('visible');
    // Restore the target tab's cached result
    trackResult.innerHTML = tabResultCache[tabName] || '';
    if (tabResultVisible[tabName]) {
      trackResult.classList.add('visible');
      // Re-wire order card click handlers after restoring HTML
      if (tabName === 'email') {
        trackResult.querySelectorAll('.kl-hc-track-order-card').forEach(function(card) {
          card.addEventListener('click', function() {
            fetchOrderDetail(this.getAttribute('data-order-num'), currentLookupEmail);
          });
        });
      }
    } else {
      trackResult.classList.remove('visible');
    }
  }

  document.querySelectorAll('.kl-hc-track-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      setTrackTab(this.getAttribute('data-track-tab'));
    });
  });

  // -- Email form: look up recent orders --
  if (emailForm) {
    emailForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = document.getElementById('klHcEmail').value.trim();
      if (!email) return;
      var orderNum = document.getElementById('klHcOrderNum').value.trim().replace(/^#/, '');

      var btn = document.getElementById('klHcEmailSubmit');
      setLoading(btn, true);
      trackError.classList.remove('visible');
      trackResult.innerHTML = '';
      trackResult.classList.remove('visible');

      var payload = { email: email };
      if (orderNum) payload.orderNumber = orderNum;

      fetch(TRACK_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
      .then(function(resp) {
        setLoading(btn, false);
        if (!resp.ok) {
          trackError.textContent = resp.data.error || 'Something went wrong.';
          trackError.classList.add('visible');
          return;
        }
        currentLookupEmail = email;
        if (resp.data.mode === 'detail') {
          renderTrackingDetail(resp.data, email);
        } else {
          cachedOrderList = resp.data.orders;
          renderOrderList(resp.data.orders);
        }
      })
      .catch(function() {
        setLoading(btn, false);
        trackError.textContent = 'Could not connect. Please check your internet and try again.';
        trackError.classList.add('visible');
      });
    });
  }

  // -- Tracking number form: direct ParcelsApp lookup --
  if (trackNumForm) {
    trackNumForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var num = document.getElementById('klHcTrackNum').value.trim();
      if (!num) return;

      var btn = document.getElementById('klHcTrackNumSubmit');
      setLoading(btn, true);
      trackError.classList.remove('visible');
      trackResult.innerHTML = '';
      trackResult.classList.remove('visible');

      fetch(TRACK_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ trackingNumber: num })
      })
      .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
      .then(function(resp) {
        setLoading(btn, false);
        if (!resp.ok) {
          trackError.textContent = resp.data.error || 'Something went wrong.';
          trackError.classList.add('visible');
          return;
        }
        renderTrackingDetail(resp.data, null);
      })
      .catch(function() {
        setLoading(btn, false);
        trackError.textContent = 'Could not connect. Please check your internet and try again.';
        trackError.classList.add('visible');
      });
    });
  }

  // -- Render order list (email lookup result) --
  function renderOrderList(orders) {
    if (!orders || orders.length === 0) {
      trackError.textContent = 'No orders found for this email.';
      trackError.classList.add('visible');
      return;
    }

    var html = '<div class="kl-hc-track-orders">';
    html += '<div class="kl-hc-track-orders-title">' + escapeHtml(orders.length) + ' recent order' + (orders.length > 1 ? 's' : '') + '</div>';

    for (var i = 0; i < orders.length; i++) {
      var o = orders[i];
      var statusInfo = getStatusInfo(o);
      var products = (o.productTitles || []).slice(0, 2).join(', ');
      if ((o.productTitles || []).length > 2) products += ' +' + (o.productTitles.length - 2) + ' more';

      html += '<button type="button" class="kl-hc-track-order-card" data-order-num="' + escapeHtml(o.orderNumber) + '">';
      html += '<div class="kl-hc-track-order-top">';
      html += '<span class="kl-hc-track-order-num">' + escapeHtml(o.orderNumber) + '</span>';
      html += '<span class="kl-hc-track-order-date">' + formatDate(o.createdAt) + '</span>';
      html += '</div>';
      if (products) {
        html += '<div class="kl-hc-track-order-products">' + escapeHtml(products) + '</div>';
      }
      html += '<div class="kl-hc-track-order-bottom">';
      html += '<span class="kl-hc-track-order-badge ' + statusInfo.cls + '">';
      html += '<span class="kl-hc-track-order-badge-dot"></span>';
      html += escapeHtml(statusInfo.label);
      html += '</span>';
      html += '<svg class="kl-hc-track-order-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="9 18 15 12 9 6"/></svg>';
      html += '</div>';
      html += '</button>';
    }
    html += '</div>';

    trackResult.innerHTML = html;
    trackResult.classList.add('visible');

    // Wire up card clicks
    trackResult.querySelectorAll('.kl-hc-track-order-card').forEach(function(card) {
      card.addEventListener('click', function() {
        var orderNum = this.getAttribute('data-order-num');
        fetchOrderDetail(orderNum, currentLookupEmail);
      });
    });
  }

  function getStatusInfo(o) {
    var t = o.tracking || {};
    var isDelivered = t.deliveryDate || (t.status || '').toLowerCase().indexOf('delivered') !== -1;
    if (isDelivered) return { label: 'Delivered', cls: 'delivered' };
    if (o.trackingNumber) return { label: t.status || 'In Transit', cls: 'transit' };
    var fs = o.fulfillmentStatus;
    if (!fs || fs === 'unfulfilled' || fs === null) return { label: 'Being Prepared', cls: 'pending' };
    return { label: fs.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); }), cls: 'pending' };
  }

  // -- Fetch full tracking detail for one order --
  function fetchOrderDetail(orderNumber, email) {
    var cacheKey = orderNumber.replace(/^#/, '');

    // Return cached detail instantly if available
    if (cachedOrderDetails[cacheKey]) {
      renderTrackingDetail(cachedOrderDetails[cacheKey], email);
      return;
    }

    trackResult.innerHTML = '<div class="kl-hc-track-loading-detail"><div class="kl-hc-track-spinner"></div><p>Loading tracking info\u2026</p></div>';
    trackResult.classList.add('visible');
    trackError.classList.remove('visible');

    fetch(TRACK_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderNumber: cacheKey, email: email })
    })
    .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
    .then(function(resp) {
      if (!resp.ok) {
        trackError.textContent = resp.data.error || 'Something went wrong.';
        trackError.classList.add('visible');
        trackResult.innerHTML = '';
        trackResult.classList.remove('visible');
        return;
      }
      cachedOrderDetails[cacheKey] = resp.data;
      renderTrackingDetail(resp.data, email);
    })
    .catch(function() {
      trackError.textContent = 'Could not connect. Please try again.';
      trackError.classList.add('visible');
      trackResult.innerHTML = '';
      trackResult.classList.remove('visible');
    });
  }

  // -- Render tracking detail (single order or tracking number result) --
  function renderTrackingDetail(data, email) {
    var t = data.tracking || {};
    var hasTracking = !!data.trackingNumber;
    var isDelivered = t.deliveryDate || (t.status || '').toLowerCase().indexOf('delivered') !== -1;
    var statusLabel, statusDesc, iconClass, iconSvg;

    if (isDelivered) {
      statusLabel = 'Delivered';
      statusDesc = t.deliveryDate ? 'Delivered on ' + formatDate(t.deliveryDate) : 'Your order has been delivered.';
      iconClass = 'delivered';
      iconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="20 6 9 17 4 12"/></svg>';
    } else if (hasTracking) {
      statusLabel = t.status || 'In Transit';
      statusDesc = t.location ? 'Last seen in ' + t.location : 'Your order is on its way.';
      iconClass = 'transit';
      iconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
    } else {
      var fs = data.fulfillmentStatus;
      if (!fs || fs === 'unfulfilled' || fs === null) {
        statusLabel = 'Being Prepared';
        statusDesc = 'Your order is being packed and will ship soon.';
      } else {
        statusLabel = fs.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
        statusDesc = 'We\u2019ll update the tracking info once it\u2019s available.';
      }
      iconClass = 'pending';
      iconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>';
    }

    var html = '';

    // Back button (only if we came from an order list)
    if (email) {
      html += '<button type="button" class="kl-hc-track-back" id="klHcTrackBack">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="15 18 9 12 15 6"/></svg>';
      html += 'Back to orders';
      html += '</button>';
    }

    html += '<div class="kl-hc-track-status">';
    html += '<div class="kl-hc-track-status-row">';
    html += '<div class="kl-hc-track-status-icon ' + iconClass + '">' + iconSvg + '</div>';
    html += '<div class="kl-hc-track-status-text"><h4>' + escapeHtml(statusLabel) + '</h4><p>' + escapeHtml(statusDesc) + '</p></div>';
    html += '</div>';

    // Detail grid
    var details = [];
    if (data.orderNumber) details.push({ label: 'Order', value: data.orderNumber });
    if (t.carrier || data.trackingCompany) details.push({ label: 'Carrier', value: t.carriers || t.carrier || data.trackingCompany });
    if (t.transitDays) details.push({ label: 'Transit', value: t.transitDays + ' days' });
    if (t.estimatedDelivery) details.push({ label: 'Est. Delivery', value: formatDate(t.estimatedDelivery) });

    if (details.length > 0) {
      html += '<div class="kl-hc-track-details">';
      for (var i = 0; i < details.length; i++) {
        html += '<div class="kl-hc-track-detail"><label>' + details[i].label + '</label><span>' + escapeHtml(String(details[i].value)) + '</span></div>';
      }
      html += '</div>';
    }

    // Checkpoints timeline
    var cps = t.checkpoints || [];
    if (cps.length > 0) {
      html += '<div class="kl-hc-track-timeline">';
      html += '<div class="kl-hc-track-timeline-title">Tracking History</div>';
      for (var j = 0; j < cps.length; j++) {
        var cp = cps[j];
        html += '<div class="kl-hc-track-checkpoint">';
        html += '<div class="kl-hc-track-dot-col"><div class="kl-hc-track-dot"></div><div class="kl-hc-track-line"></div></div>';
        html += '<div class="kl-hc-track-cp-text">';
        html += '<div class="kl-hc-track-cp-status">' + escapeHtml(cp.status || 'Update') + '</div>';
        var meta = [];
        if (cp.date) meta.push(formatDate(cp.date));
        if (cp.location) meta.push(cp.location);
        if (cp.carrier) meta.push(cp.carrier);
        if (meta.length) html += '<div class="kl-hc-track-cp-meta">' + escapeHtml(meta.join(' \u00b7 ')) + '</div>';
        html += '</div></div>';
      }
      html += '</div>';
    }

    // Last mile link
    if (t.lastMileUrl && /^https?:\/\//i.test(t.lastMileUrl)) {
      html += '<a href="' + escapeHtml(t.lastMileUrl) + '" target="_blank" rel="noopener" class="kl-hc-track-lastmile">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';
      html += 'Track on ' + escapeHtml(t.lastMileService || 'carrier website');
      html += '</a>';
    }

    html += '</div>';
    trackResult.innerHTML = html;
    trackResult.classList.add('visible');

    // Wire up back button
    var backBtn = document.getElementById('klHcTrackBack');
    if (backBtn) {
      backBtn.addEventListener('click', function() {
        if (cachedOrderList) {
          renderOrderList(cachedOrderList);
          return;
        }
        trackResult.innerHTML = '<div class="kl-hc-track-loading-detail"><div class="kl-hc-track-spinner"></div><p>Loading orders\u2026</p></div>';
        fetch(TRACK_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: currentLookupEmail })
        })
        .then(function(res) { return res.json().then(function(d) { return { ok: res.ok, data: d }; }); })
        .then(function(resp) {
          if (!resp.ok) {
            trackError.textContent = resp.data.error || 'Something went wrong.';
            trackError.classList.add('visible');
            trackResult.innerHTML = '';
            trackResult.classList.remove('visible');
            return;
          }
          cachedOrderList = resp.data.orders;
          renderOrderList(resp.data.orders);
        })
        .catch(function() {
          trackError.textContent = 'Could not connect. Please try again.';
          trackError.classList.add('visible');
          trackResult.innerHTML = '';
          trackResult.classList.remove('visible');
        });
      });
    }
  }

  // ============ SUBSCRIPTION DRAWER ============
  var subDrawer = document.getElementById('klHcSubDrawer');
  var subOverlay = document.getElementById('klHcSubOverlay');
  var subClose = document.getElementById('klHcSubClose');
  var subForm = document.getElementById('klHcSubForm');
  var subError = document.getElementById('klHcSubError');
  var subSuccess = document.getElementById('klHcSubSuccess');
  var subResend = document.getElementById('klHcSubResend');

  function openSubDrawer() {
    if (!subDrawer) return;
    subDrawer.classList.add('open');
    subOverlay.classList.add('open');
    /* iOS/Instagram scroll lock — position:fixed trick */
    drawerScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + drawerScrollY + 'px';
    document.body.style.width = '100%';
  }

  function closeSubDrawer() {
    if (!subDrawer) return;
    /* kl-closing carries the close-direction transition. Default state has
       transition: none so the drawer can never animate on page load. */
    subDrawer.classList.add('kl-closing');
    subDrawer.classList.remove('open');
    subOverlay.classList.remove('open');
    /* Restore scroll — undo iOS position:fixed trick */
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, drawerScrollY);
    subDrawer.addEventListener('transitionend', function onEnd(e) {
      if (e.target !== subDrawer || e.propertyName !== 'transform') return;
      subDrawer.classList.remove('kl-closing');
      subDrawer.removeEventListener('transitionend', onEnd);
    });
  }

  if (subDrawer) {
    if (subClose) subClose.addEventListener('click', closeSubDrawer);
    if (subOverlay) subOverlay.addEventListener('click', closeSubDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && subDrawer.classList.contains('open')) {
        closeSubDrawer();
      }
    });
  }

  function submitSubEmail() {
    var emailInput = document.getElementById('klHcSubEmail');
    var email = emailInput ? emailInput.value.trim() : '';
    if (!email) return;

    var btn = document.getElementById('klHcSubSubmit');
    btn.querySelector('.kl-hc-track-submit-label').style.display = 'none';
    btn.querySelector('.kl-hc-track-submit-loading').style.display = '';
    btn.disabled = true;
    subError.classList.remove('visible');
    subError.textContent = '';

    // Call Loop's magic link API directly (CORS allowed from any origin)
    fetch('https://api.loopwork.co/api/customer/v2/send_login_link_email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, myshopify_domain: 'kallistiashop.myshopify.com' })
    })
    .then(function(res) {
      // Show success regardless (don't reveal whether email has a subscription)
      subForm.style.display = 'none';
      document.getElementById('klHcSubSentEmail').textContent = email;
      subSuccess.style.display = '';
    })
    .catch(function() {
      // Even on error, show success for privacy
      subForm.style.display = 'none';
      document.getElementById('klHcSubSentEmail').textContent = email;
      subSuccess.style.display = '';
    })
    .finally(function() {
      btn.querySelector('.kl-hc-track-submit-label').style.display = '';
      btn.querySelector('.kl-hc-track-submit-loading').style.display = 'none';
      btn.disabled = false;
    });
  }

  if (subForm) {
    subForm.addEventListener('submit', function(e) {
      e.preventDefault();
      submitSubEmail();
    });
  }

  if (subResend) {
    subResend.addEventListener('click', function() {
      subSuccess.style.display = 'none';
      subForm.style.display = '';
      submitSubEmail();
    });
  }

  var subDiffEmail = document.getElementById('klHcSubDiffEmail');
  if (subDiffEmail) {
    subDiffEmail.addEventListener('click', function() {
      subSuccess.style.display = 'none';
      subForm.style.display = '';
      var emailInput = document.getElementById('klHcSubEmail');
      if (emailInput) { emailInput.value = ''; emailInput.focus(); }
    });
  }

  // ============ DATA-ATTRIBUTE TRIGGERS ============
  // Any element with data-kl-track-trigger or data-kl-sub-trigger will open the drawer
  document.querySelectorAll('[data-kl-track-trigger]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      openTrackDrawer();
    });
  });

  document.querySelectorAll('[data-kl-sub-trigger]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      openSubDrawer();
    });
  });

  // ============ GLOBAL EXPOSURE ============
  // Other scripts (e.g. kl-help-center.js quick links) can call window.klDrawers.openTrack()
  window.klDrawers = {
    openTrack: openTrackDrawer,
    openSub: openSubDrawer
  };

})();
